import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import Cookie from 'js-cookie';

const config = JSON.parse(Config);

export const LOGISTICS_HANDOVERS = async (url, userId, month, year) => {
  let body = [];
  let stores = [];
  let colorCodes = [];
  let storeID = [];
  let checkListDate = [];
  let dmName = [];
  let statusData = [];
  let handoverStatusReports = [];
  let proxyjson = [];
  let body_weekly = [];
  let stores_weekly = [];
  let colorCodes_weekly = [];
  let storeID_weekly = [];
  let body_monthly = [];
  let stores_monthly = [];
  let colorCodes_monthly = [];
  let storeID_monthly = [];
  let colorCodeLogic = [];

  const fetchedData = await ApiGateWay.Post(config['api'] + url, {
    userId: userId,
    month: month,
    year: year,
  })
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }

      response.handOverDailyGlobalDashBoards.map((name, val) => {
        name.storeInfo
          .sort((a, b) => (a.storeName > b.storeName ? 1 : -1))
          .map((value, index) => {
            value.checklistInfos.map((val, ind) => {
              storeID.push(value.storeId);
              stores.push(value.storeName);
              body.push([name.handoverStatus, val.checklistDate, val.dmName]);
              checkListDate.push(val.checklistDate);
              dmName.push(val.dmName);
              statusData.push(name.handoverStatus);
              val.checklistDate != 'Not done'
                ? colorCodes.push([0, 2, 2])
                : colorCodes.push([0, 1, 1]);
              handoverStatusReports.push([checkListDate, dmName, statusData]);
            });
          });
      });

      response.handOverWeeklyGlobalDashBoards
        .sort((a, b) => (a.storeName > b.storeName ? 1 : -1))
        .map((name, val) => {
          storeID_weekly.push(name.storeId == null ? '' : name.storeId);
          stores_weekly.push(name.storeName == null ? '' : name.storeName);
          name.storeName != 'Not done'
            ? colorCodes_weekly.push([0, 2, 2])
            : colorCodes_weekly.push([0, 1, 1]);
          body_weekly.push([
            name.handoverStatus,
            name.week == null ? '' : name.week,
            name.dmName == null ? '' : name.dmName,
          ]);
        });

      response.handOverMonthlyGlobalDashBoards
        .sort((a, b) => (a.storeName > b.storeName ? 1 : -1))
        .map((name, val) => {
          colorCodeLogic = [];
          storeID_monthly.push(name.storeId);
          stores_monthly.push(name.storeName);

          parseInt(name.monthlySod.split('%')[0]) >= 90
            ? colorCodeLogic.push(1)
            : colorCodeLogic.push(2);
          colorCodes_monthly.push(colorCodeLogic);
          body_monthly.push([name.monthlySod]);
        });

      return (proxyjson = {
        proxyjson: {
          type: 'Handovers',
          thead: ['Store Name', 'Daily Handover Status', 'Date', 'DM'],
          storeId: storeID,

          tbody: body,
          columns: ['Store Name', 'Daily Handover Status', 'Date', 'DM'],
          stores: stores,
          colorCodes: colorCodes,
          popUpDataGrid: body,
          popUpDataGridHeaders: ['Not Required'],
        },
        proxyJsonWeeklyCheckList: {
          type: 'Handovers',
          thead: ['Store', 'Weekly Handover Status', 'Week', 'DM'],
          storeId: storeID_weekly,
          tbody: body_weekly,
          columns: ['Store', 'Weekly Handover Status', 'Week', 'DM'],
          stores: stores_weekly,
          colorCodes: colorCodes_weekly,
          popUpDataGrid: body_weekly,
          popUpDataGridHeaders: ['Not Required'],
        },
        proxyJsonMonthlyCheckList: {
          type: 'Handovers',
          thead: ['Store', 'Monthly SOD'],
          storeId: storeID_monthly,
          tbody: body_monthly,
          columns: ['Store', 'Monthly SOD'],
          stores: stores_monthly,
          colorCodes: colorCodes_monthly,
          popUpDataGrid: body_monthly,
          popUpDataGridHeaders: [
            'Sport Name',
            'Checklist Date',
            'Checklist Score',
            'Handover Status',
            'User Name',
          ],
        },
      });
    });
  return fetchedData;
};
